// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"1e946f87","280":"a703db3c","332":"ebfabb1a","334":"dd77f3f5","416":"435754f9","470":"904a51a7","538":"7502cfce","560":"494a5b21","566":"f6efb146","687":"3a3c4f57","808":"5837a568","972":"315f0597","985":"1d86fb22"}[chunkId] + ".chunk.js";
};